export default __webpack_public_path__ + "static/media/Background 5_00030.08cfdddf.png";